const MONTHS = ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.']

/** Formats an ISO timestamp as a Norwegian date, identically on server and client. */
export const formatDate = (iso: string): string => {
    const date = new Date(iso)

    if (Number.isNaN(date.getTime())) return ''

    return `${date.getUTCDate()}. ${MONTHS[date.getUTCMonth()]} ${date.getUTCFullYear()}`
}

/** Groups thousands with a narrow no-break space, Norwegian style: 1 599, 800 000. */
export const formatNumber = (value: number): string => {
    const [int, dec] = Math.abs(value).toFixed(0).split('.')
    const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

    return `${value < 0 ? '-' : ''}${grouped}${dec ? `,${dec}` : ''}`
}
